import type { LibraryDifficulty } from "./libraryFilters";

// Structural t-signature — the repo has no direct i18next dep to import
// TFunction from; every caller passes useTranslation()'s t.
type Translate = (key: string, opts?: { defaultValue?: string }) => string;

// ONE difficulty → localized label mapping (the templates.* keys shipped
// in 1.50.0, library.catalog.* since #472). Extracted when the Library filter panel became the
// third caller (LibraryItemCard + TemplatesShelf hand-rolled the same
// ternary; the shelf retires with HR-S4, the card now imports this).
export const difficultyLabel = (d: LibraryDifficulty, t: Translate): string =>
  d === "beginner"
    ? t("library.catalog.difficultyBeginner", { defaultValue: "Beginner" })
    : d === "intermediate"
      ? t("library.catalog.difficultyIntermediate", { defaultValue: "Intermediate" })
      : t("library.catalog.difficultyAdvanced", { defaultValue: "Advanced" });
